import type CalendarsCacheStore from "./schema/CalendarsCacheStore";
import { createStore } from "owa-satcheljs";
const defaultCalendarsCacheStore: CalendarsCacheStore = {
    calendarEntryMapping: new Map(),
    folderIdToCalendarId: new Map(),
    validEntryMapping: new Map(),
    calendarGroupsMapping: new Map(),
    defaultCalendars: new Map(),
    sharedFolderIdMapping: new Map(),
    calendarIdOrderedList: [],
    calendarGroupKeyOrderedList: [],
    calendarDuplicateIdMapping: new Map(),
};

const getStore: () => CalendarsCacheStore = createStore<CalendarsCacheStore>("calendarsCacheStore", defaultCalendarsCacheStore);

export default getStore;
